export default __webpack_public_path__ + "static/media/SPRYT.d8ebe6cc.png";